import * as React from 'react';
import PriceDisplay from '../../../../../../components/Others/PriceDisplay';
import { getPriceWithout } from 'src/helpers/Prices/getPrice';

export interface IInsuranceLimitRowProps {
  limit: GQL.IDeliveryMethodInsuranceLimit;
  currency: GQL.ICurrency;
  onClick?: Function;
}

export default class InsuranceLimitRow extends React.Component<IInsuranceLimitRowProps> {

  public render() {
    const { limit, currency } = this.props;

    return (
      <div
        onClick={(e: any) => {
          if (this.props.onClick) {
            this.props.onClick(e);
          }
        }}
        style={{
          cursor: this.props.onClick ? 'pointer' : '',
          width: '100%',
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-start',
            alignItems: 'center',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'flex-start', flexDirection: 'column', width: '70%' }}>
            {`${this.definitionPriceRange(limit)}`}
          </div>
          <div style={{ display: 'flex', alignItems: 'flex-end', flexDirection: 'column', width: '30%' }}>
            <PriceDisplay prices={limit.prices as any || []} currency={currency} />
          </div>
        </div>
      </div>
    );
  }

  private definitionPriceRange(limit: GQL.IDeliveryMethodInsuranceLimit) {
    const { currency } = this.props;

    let result = '';
    
    if (limit && limit.fromPriceOrder && getPriceWithout(limit.fromPriceOrder, currency) > 0) {
      result = `min ${getPriceWithout(limit.fromPriceOrder, currency)} EUR`;
    }
    
    if (limit && limit.toPriceOrder && getPriceWithout(limit.toPriceOrder, currency) > 0) {
      if (result !== '') {
        result += `, `;
      }
      result += `max ${getPriceWithout(limit.toPriceOrder, currency)} EUR`;
    }

    if (result === '') {
      return 'any order price';
    }

    return result;
  }
}



// WEBPACK FOOTER //
// ./src/scenes/DeliveryMethods/DeliveryMethodDetail/components/Insurance/components/InsuranceLimitRow.tsx